<mat-list class="sections-list">
  <mat-list-item
    *ngFor="let label of sections"
    [class.active]="label.type === activeSection"
    (click)="changeSection.emit(label.type)"
  >
    {{ text[label.Name] || label.Name }}
  </mat-list-item>
</mat-list>
